import React, { useState } from "react";
import { useSelector } from "react-redux";
import Card from "app/components/Card";
import { Skeleton } from "app/components/Skeleton";
import TicketLimit from "../TicketLimit";
import ColumnGroupActions from "../ColumnGroupActions";
import { selectDraftBoardForm } from "../../../../components/Settings/redux/selector";
import GroupLabel from "./GroupLabel";
import { useGroupMeta } from "./useGroupMeta";
import { IGroupHeaderMeta, TicketGroup } from "../../../Tickets/types";
import AddTicketGroupModal from "../AddTicketGroupModal";

interface GroupHeaderProps {
  group: TicketGroup;
  loading: boolean;
}

const GroupHeader: React.FC<GroupHeaderProps> = ({ group, loading }) => {
  const boardFormData = useSelector(selectDraftBoardForm);
  const groupBy = boardFormData?.groupBy;
  let ticketCount = group?.tickets?.length || 0;
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  if (boardFormData.subGroupBy && boardFormData.subGroupBy !== "none") {
    ticketCount =
      group?.subGroups?.reduce(
        (acc, sub) => acc + (sub.tickets?.length || 0),
        0,
      ) || ticketCount;
  }
  const meta = useGroupMeta(group._id);

  if (loading) {
    return (
      <Card className="rounded-[6px] !p-[10px]">
        <Skeleton className="h-[20px] w-1/2" />
      </Card>
    );
  }

  return (
    <Card className="rounded-[6px] p-[10px]">
      <div className="flex items-center justify-between gap-[6px]">
        <div className="flex items-center gap-[6px]">
          <GroupLabel
            group={group}
            groupBy={groupBy}
            meta={meta as IGroupHeaderMeta}
          />

          <TicketLimit
            group={group}
            count={ticketCount}
            maxCount={group?.ticketLimit}
          />
        </div>

        <ColumnGroupActions
          group={group}
          onAddNewGroup={() => setIsAddModalOpen(true)}
        />
      </div>
      {isAddModalOpen && (
        <AddTicketGroupModal
          onClose={() => setIsAddModalOpen(false)}
          isEditGroup={false}
        />
      )}
    </Card>
  );
};

export default React.memo(GroupHeader);
